import React, { PropTypes } from 'react';
import classnames from 'classnames';
import Attribute from 'marketing/common/attribute';

const SingleTestimonial = ({ project_image, testimonial_author, headline,
                             content_html, className }) => (
  <section className={classnames("block block-single-testimonial", className)}>
    <div className="row">
      <div className="columns small-16 medium-8 medium-offset-2 medium-order-2">
        <div className="quote">
          <h2>{headline}</h2>
          <p dangerouslySetInnerHTML={{ __html: content_html }} />
        </div>
        <div className="quote-meta">
          {testimonial_author.image &&
            <img src={testimonial_author.image.url} alt={testimonial_author.image.alt} className="avatar avatar-lg avatar-round avatar-team"/>
          }
          <div className="author-name">{ testimonial_author.name }</div>
          { testimonial_author.extra && <h5>{ testimonial_author.extra }</h5> }
          <div className="clearfix"/>
        </div>
      </div>
      <div className="columns small-16 medium-6 medium-order-1">
        <div className="quote-image">
          <img src={project_image.url} alt={project_image.alt}/>
          {project_image.creative &&
            <Attribute to={project_image.creative}/>
          }
        </div>
      </div>
    </div>
  </section>
);

SingleTestimonial.propTypes = {
  project_image: PropTypes.object,
  testimonial_author: PropTypes.object,
  headline: PropTypes.string,
  content_html: PropTypes.string,
  className: PropTypes.string,
};

export default SingleTestimonial;



// WEBPACK FOOTER //
// ./landing_pages/components/single_testimonial.jsx